import React from 'react';

import { classnames } from '@src/utils/classnames';
import { GroupBase } from 'react-select';
import { IOptionBase, ISelectInputProps } from '../models';
import styled from './SelectInput.module.scss';

export const SelectInput = <
  OptionType extends IOptionBase,
  GroupType extends GroupBase<OptionType>,
  IsMulti extends boolean,
>(
  props: ISelectInputProps<OptionType, GroupType, IsMulti>,
) => {
  const { innerRef, selectProps, onBlur, role, onChange, onFocus, type, value } = props;
  const classes = classnames(styled.root, selectProps.classNamePrefix);

  return (
    <div className={styled.wrapper} data-value={value}>
      <input
        autoCapitalize="none"
        autoComplete="off"
        autoCorrect="off"
        spellCheck="false"
        tabIndex={0}
        aria-autocomplete="list"
        aria-expanded="true"
        aria-haspopup="true"
        role={role}
        data-elem="select-input"
        type={type}
        className={classes}
        disabled={selectProps.disabled}
        onBlur={onBlur}
        onChange={onChange}
        onFocus={onFocus}
        ref={innerRef}
        value={value}
      />
    </div>
  );
};
